import { render, staticRenderFns } from "./CustomCompanyOverrides.vue?vue&type=template&id=67b40182"
import script from "./CustomCompanyOverrides.vue?vue&type=script&lang=ts"
export * from "./CustomCompanyOverrides.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports